/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NgxAuthComponent,
  NgxLoginComponent,
  NgxRegisterComponent,
  NgxLogoutComponent,
  NgxRequestPasswordComponent,
  NgxResetPasswordComponent,
  RegisterTenantComponent,
  TenantListComponent,
  PatientLoginComponent,
  PatientSignupComponent,
  PatientVideocallLoginComponent,
  ResetPasswordInsideAppComponent
} from './components'; 
import { PatientVideocallComponent } from './components/patient-videocall/patient-videocall.component';
import { DoctorSignupComponent } from './components/doctor/doctor-signup/doctor-signup.component';
import { PatientportalloginComponent } from './components/patientportallogin/patientportallogin.component';
import { PortalAppointmentBookingComponent } from './components/portal-appointment-booking-component/portal-appointment-booking-component.component';
import { BookingSummaryLoginComponent } from './components/booking-summary-login/booking-summary-login.component';
import { QueuemanagementComponent } from './components/queuemanagement/queuemanagement.component';

const routes: Routes = [{
  path: '',
  component: NgxAuthComponent,
  children: [
    {
      path: '',
      component: NgxLoginComponent,
    },
    {
      path: 'login',
      component: NgxLoginComponent,
    },
    {
      path: 'register/:userId',
      component: NgxRegisterComponent,
    },
    {
      path: 'logout',
      component: NgxLogoutComponent,
    },
    {
      path: 'request-password',
      component: NgxRequestPasswordComponent,
    },
    {
      path: 'reset-password',
      component: NgxResetPasswordComponent,
    },
    {
      path: 'register-tenant',
      component: RegisterTenantComponent,
    },
    {
      path: 'tenant-list',
      component: TenantListComponent,
    },
    {
      path: 'login/:newTenant',
      component: NgxLoginComponent,
    },
    {
      path: 'patient-login-iframe',
      component: PatientLoginComponent,
    }, 
    {
      path: 'patient-portal',
      component: PatientportalloginComponent,
    }, 
    {
      path: 'patient-signup',
      component: PatientSignupComponent,
    },
    {
      path: 'doctor-signup',
      component: DoctorSignupComponent,
    },
    {
      path: 'reset-pwd-inside-app',
      component: ResetPasswordInsideAppComponent,
    },
    {
      path: 'patient-videocall-check/token/:roomID/id/:Id/:regId/:docId',
      component: PatientVideocallLoginComponent,
    },
    { path: 'patient-join-call/:roomId/:regId', component: PatientVideocallComponent },
    // { path: 'patient-portal-appointment-booking', component: PortalAppointmentBookingComponent },
    // { path: 'patient-portal-appointment-booking/:from', component: PortalAppointmentBookingComponent },
    // { path: 'patient-portal-booking-summary/:value1/:value2/:value3/:value4/:value5', component: BookingSummaryLoginComponent },
    { path: 'queue/:customerId/:passCode', component: QueuemanagementComponent },
    { path: 'queue/:customerId/:passCode/:deviceId', component:  QueuemanagementComponent },

  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {
}
